import { Avatar, Box, Card, CardContent, CircularProgress, Container, createStyles, Grid, Link, makeStyles, TextField, Theme, Typography } from '@material-ui/core';
import { Field, Form, Formik, FormikProps } from 'formik';
import { useCallback, useEffect, useRef, useState } from 'react';
import CustomButton, { ButtonColorEnum, ButtonTypeEnum, ButtonVariantEnum } from '../../components/CustomButton/custom-button.component';
import SSOComponent from '../../components/SSO/sso.component';
import ResetPasswordComponent from '../../components/ResetPassword/reset-password.component'
import * as Yup from 'yup';
// import { Redirect } from 'react-router'
import * as models from '../../models';
import { useHistory, useLocation } from 'react-router';
import queryString from 'query-string';
import { useAsyncError } from 'src/hooks/useAsyncError';
import { UserService } from 'src/services/user.service';
import { clientRoutes, Placeholder } from 'src/shared/constants';
import { useTranslation } from 'react-i18next';
import Checkbox from '@material-ui/core/Checkbox';
import logoText from './../../assets/images/logo.png';
import environment from 'src/environment/environment';
import { SharedService } from 'src/services/shared.service';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			padding: "0"
		},
		text: {
			paddingTop: "236px",
			marginBottom: "48px",
			fontWeight: 550,
			fontSize: "18px",
		},
		card: {
			height: "400px"
		},
		form: {
			justifyContent: "space-between",
			height: "100%",
			paddingBottom: "36px"
		},
		loginButton: {
			marginTop: "3px",
			background: "#3D4C6B"
		},
		checkbox: {
			height: "12px",
			width: "12px"
		},
		checkboxLabel: {
			fontSize: "13px",
			paddingLeft: "4px",
			cursor: "pointer"
		},
		font13px: {
			fontSize: "13px"
		}
	})
);

interface ISignInFormFields {
	email: string;
	password: string;
}

const SigninSchema = Yup.object().shape<ISignInFormFields>({
	email: Yup.string().required('Email is required'),
	password: Yup.string().required('Password is required'),
});

const FormFactory = (): ISignInFormFields => {
	return {
		email: '',
		password: '',
	};
};

const SigninComponent = () => {
	const { t } = useTranslation();
	const classes = useStyles();
	const history = useHistory();
	const location = useLocation();
	const throwError = useAsyncError();

	const [isSSOSignIn, setIsSSOSignIn] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);
	const [resetDialogOpen, setResetDialogOpen] = useState(false);
	const [isStaySignedIn, setIsStaySignedIn] = useState<boolean>(false);

	const formRef = useRef<FormikProps<ISignInFormFields>>(null);
	const appVersion = environment.version;
	var userService: UserService = new UserService();

	// const onUserSignIn = useCallback(async (values: models.ISignInRequest) => {
	// 	try {
	// 		setLoading(true);
	// 		const userService = new UserService();
	// 		const result = await userService.SignIn(values);
	// 		if (Boolean(result)) {
	// 			UserService.SetLocalUserData(result, isStaySignedIn);
	// 			// If redirecting from website, we need to redirect user to same path after login
	// 			history.push((history.location.state as any)?.from?.toString() || clientRoutes.dashboard);
	// 		}
	// 		setLoading(false);
	// 	} catch (error) {
	// 		setLoading(false);
	// 		throwError(error);
	// 	}
	// }, [history, throwError, isStaySignedIn]);

	// useEffect(() => {
	// 	const queryParams = queryString.parse(location.search);
	// 	const ssoCode = queryParams['sso_code'] as string;

	// 	if (ssoCode) {
	// 		setIsSSOSignIn(true);
	// 		onUserSignIn({
	// 			ssoCode
	// 		}).catch(() => setIsSSOSignIn(false));
	// 	}
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [location.search])

	const renderAuthMSAuthorizePage = () => {
		UserService.removeCodeVerifierFromSession();
		const codeVerifier = userService.createCodeVerifier();
		UserService.setCodeVerifierInSession(codeVerifier);

		const authMSAuthorizeUrl = environment.authMS.authMSAuthorizeUrl
			.replace(Placeholder.productId, environment.authMS.productId)
			.replace(Placeholder.grantType, environment.authMS.grantType)
			.replace(Placeholder.redirectUri, environment.authMS.redirectUri)
			.replace(Placeholder.state, SharedService.getGuid())
			.replace(Placeholder.codeChallenge, userService.createCodeChallenge(codeVerifier));

		window.location.href = authMSAuthorizeUrl;
	}

	const getAuthMSAccessToken = async (authCode: string, codeVerifier: string) => {
		try {
			const result = await userService.getAuthMSAccessToken(authCode, codeVerifier);
			UserService.SetAuthMSLocalUserData(result, true);
			UserService.removeCodeVerifierFromSession();
			history.push(clientRoutes.dashboard);
		} catch (error) {
			window.location.href = environment.appSetting.baseUrl;
		}
	}

	useEffect(() => {
		const searchParams = new URLSearchParams(location.search);
		const authCode = searchParams.get("cd") || "";
		const codeVerifier = UserService.getCodeVerifierFromSession()
		if (authCode && codeVerifier) {
			getAuthMSAccessToken(authCode, codeVerifier);
		} else {
			renderAuthMSAuthorizePage();
		}
	}, [])


	return <div className='app-loading-container'>
		<div className="app-loading">
			<div className="logo"></div>
			<svg className="spinner" viewBox="25 25 50 50">
				<circle className="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
			</svg>
		</div>
	</div>

	// if (isSSOSignIn) {
	// 	return (
	// 		<Container maxWidth='xs'>
	// 			<Box mt={10}>
	// 				<Card>
	// 					<CardContent>
	// 						<Box display='flex' justifyContent='center'>
	// 							<Avatar alt='Impledge Logo' src={require('./../../assets/images/it_round.png').default} />
	// 						</Box>
	// 						<Typography component='h3' variant='h6' align='center' gutterBottom>
	// 							{t("label-signing-you-in")}
	// 						</Typography>
	// 						<Box display='flex' justifyContent='center'>
	// 							<CircularProgress size={24} />
	// 						</Box>
	// 					</CardContent>
	// 				</Card>
	// 			</Box>
	// 		</Container>
	// 	);
	// }

	// return (
	// 	<div className='auth-screen-bg'>
	// 		{/* Header */}
	// 		<Box display={"flex"} alignItems={"center"} className="auth-screen-header">
	// 			<img src={logoText} height={36} width={150} />
	// 			<div className="text-bold-550 header-text">{t("label-tools")}</div>
	// 		</Box>
	// 		{/* Header End */}
	// 		<div className="no-auth">
	// 			<Grid container className="form-area">
	// 				<Grid item xs={6} className="col-6">
	// 					<div className="img-bg pt-12">
	// 						<Box className={`app-title text-bold-550 ${classes.text}`}>{t("label-tools")}</Box>
	// 						<SSOComponent />
	// 					</div>
	// 				</Grid>
	// 				<Grid item xs={6} className="col-6" spacing={1}>
	// 					<div className="auth-form">
	// 						<Typography component='h3' variant='h5' align='center' className='auth-heading'>
	// 							{t("label-login-to-account")}
	// 						</Typography>
	// 						<Formik
	// 							initialValues={FormFactory()}
	// 							onSubmit={(e: models.ISignInRequest) => onUserSignIn(e)}
	// 							validationSchema={SigninSchema}
	// 							innerRef={formRef}
	// 							render={(formikProps: FormikProps<ISignInFormFields>) => (
	// 								<Form noValidate={true} className={`auth-form ${classes.form}`}>
	// 									<div>
	// 										<Field
	// 											className="mb-0 auth-form-field-height"
	// 											name='email'
	// 											label='Email'
	// 											margin='normal'
	// 											variant='standard'
	// 											component={TextField}
	// 											value={formikProps.values.email}
	// 											type='email'
	// 											required={true}
	// 											fullWidth={true}
	// 											onChange={(e: React.ChangeEvent) => formikProps.handleChange('email')(e)}
	// 											error={
	// 												!!((formikProps.values.email.length || formikProps.submitCount) && !!formikProps.errors.email)
	// 											}
	// 											helperText={
	// 												formikProps.values.email.length || formikProps.submitCount ? formikProps.errors.email : null
	// 											}
	// 										/>
	// 										<Field
	// 											className="mb-0 auth-form-field-height"
	// 											name='password'
	// 											label='Password'
	// 											margin='normal'
	// 											variant='standard'
	// 											component={TextField}
	// 											value={formikProps.values.password}
	// 											type='password'
	// 											required={true}
	// 											fullWidth={true}
	// 											onChange={(e: React.ChangeEvent) => formikProps.handleChange('password')(e)}
	// 											error={
	// 												!!(
	// 													(formikProps.values.password.length || formikProps.submitCount) &&
	// 													!!formikProps.errors.password
	// 												)
	// 											}
	// 											helperText={
	// 												formikProps.values.password.length || formikProps.submitCount ? formikProps.errors.password : null
	// 											}
	// 										/>
	// 										<Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} className={classes.font13px}>
	// 											<Box>
	// 												<Checkbox
	// 													className={classes.checkbox}
	// 													checked={isStaySignedIn}
	// 													color="primary"
	// 													size="small"
	// 													onChange={() => setIsStaySignedIn(!isStaySignedIn)}/>
	// 												<span className={classes.checkboxLabel} onClick={() => setIsStaySignedIn(!isStaySignedIn)}>{t("label-stay-logged-in")}</span>
	// 											</Box>
	// 											<Link className='link-text' href='#' onClick={() => setResetDialogOpen(true)}>
	// 												{t("label-forgot-password")}
	// 											</Link>
	// 										</Box>
	// 									</div>

	// 									<CustomButton
	// 										className={classes.loginButton}
	// 										variant={ButtonVariantEnum.Contained}
	// 										disabled={loading}
	// 										loading={loading}
	// 										buttonText={t('label-log-in')}
	// 										fullWidth
	// 										type={ButtonTypeEnum.Submit}
	// 									/>
	// 								</Form>
	// 							)}
	// 						/>
	// 					</div>
	// 					<div className="below-form">
	// 						<div>
	// 							<span className="font17px">{t("label-new-to-app")}</span>
	// 						</div>
	// 						<div>
	// 							<span className="font12px">{t("label-get-started")}</span>
	// 						</div>
	// 						<div className="pt-12">
	// 							<CustomButton
	// 								className={"bg-white"}
	// 								fullWidth
	// 								variant={ButtonVariantEnum.Contained}
	// 								color={ButtonColorEnum.Inherit}
	// 								onClick={() => history.push('/signup', history?.location?.state)}
	// 								type={ButtonTypeEnum.Button}
	// 								buttonText={t("label-create-new-account")} />
	// 						</div>
	// 					</div>
	// 				</Grid>
	// 			</Grid>
	// 			{/* App version */}
	// 			<div className='bottom-dark'>
	// 				<div className='build-version'>{t("label-build")}{appVersion}</div>
	// 			</div>
	// 		<ResetPasswordComponent open={resetDialogOpen} onClose={() => setResetDialogOpen(false)} email={formRef.current?.values.email} />
	// 		</div>
	// 	</div>
	// );
};

export default SigninComponent;
